import React, { useEffect } from "react"
import Col from "@bappweb/col"
import Grid from "@bappweb/grid"
import Row from "@bappweb/row"
import Block from "@bappweb/block"
import MainForm from "./form"
import LandingHeader from "./landingheader"

const Landing = () => {
    return (
        <Block type="section" className="landing-page-wrapper" id="landing-page-wrapper">
            <LandingHeader />
        </Block>
    )
}

export default Landing
